import { Route, Redirect, RouteProps } from 'react-router-dom';

interface Props extends RouteProps {
  user?: {
    isAuthenticated?: boolean;
  };
  redirectToSignUp?: boolean;
  component: React.ComponentType<any>;
}

const RestrictedRoute: React.FC<Props> = ({
  user,
  component: Component,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        user?.isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: rest.redirectToSignUp ? '/sign-up' : '/login',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default RestrictedRoute;
